import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { LoginResponse } from "../../../../apis/model/authAdmin.model";
import authAdminService from "../../../../apis/admin/authAdminService";
import {LOCAL_STORAGE_TOKEN_ADMIN_CMS, USER_INFO} from "../../../../configs/auth";
import { RootState } from "../../../../app/store";

type UserListState = {
    auth: {}
    isLoading: boolean
}

const initialState: UserListState = {
    auth: {},
    isLoading: true
}


export const authAdmin = createAsyncThunk(
    'auth/Admin',
    async ({ username, password }: { username: string; password: string },
        thunkApi) => {
        try {
            const response = await authAdminService.loginCMS(username, password)
            return response.data
        } catch (error) {
            return thunkApi.rejectWithValue(error)
        }
    },
)

const authAdmins = createSlice({
    name: 'authAdmin',
    initialState,
    reducers: {
        setUsers:(state,action)=> {
            state.auth = action.payload
            localStorage.setItem(USER_INFO,JSON.stringify(action.payload))
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(authAdmin.pending, (state) => {
                return state
            })
            .addCase(authAdmin.fulfilled, (state, acction: any) => {
                localStorage.setItem(LOCAL_STORAGE_TOKEN_ADMIN_CMS, acction.payload.data.payload.token)

                return state;
            })
            .addCase(authAdmin.rejected, (state) => {
                return state
            })
    }
})

export const { setUsers } = authAdmins.actions
export const dataAuth = (state: RootState) => state.auth
export default authAdmins.reducer
